import { render, staticRenderFns } from "./ApplicantAddPage.vue?vue&type=template&id=3a334194"
import script from "./ApplicantAddPage.vue?vue&type=script&lang=ts"
export * from "./ApplicantAddPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\808325\\Documents\\SsmlockEntryReqWebApp-IVC202512\\SsmlockEntryReqWebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a334194')) {
      api.createRecord('3a334194', component.options)
    } else {
      api.reload('3a334194', component.options)
    }
    module.hot.accept("./ApplicantAddPage.vue?vue&type=template&id=3a334194", function () {
      api.rerender('3a334194', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/applicant/ApplicantAddPage.vue"
export default component.exports